export default __webpack_public_path__ + "static/media/RvGrey.21d7a5b0.svg";